export default "__VITE_ASSET__DFHi1hii__"